import * as React from 'react';
import type {
  CTAWidgetPayload,
  ActionEvent,
} from 'src/components/agentic-ui/types';

import {BodyMedium, Button} from '@spaced-out/ui-design-system';
import css from './cta-widget.css';


interface CTAWidgetProps {
  data: CTAWidgetPayload;
  publishMessageAction?: (action: ActionEvent) => void;
}

const CTAWidget = ({
  data,
  publishMessageAction,
}: CTAWidgetProps): React.ReactNode => {
  try {
    const {title = '', items = []}: CTAWidgetPayload = data;

    return (
      <div className={css.ctaWidgetContainer}>
        <BodyMedium>{title}</BodyMedium>
        <div className={css.ctaWidgetButtonsContainer}>
          {items.map((item: any) => {
            switch (item.type) {
              case 'button':
                const {product, name, payload} = item.event;
                return (
                  <Button
                    key={item.id}
                    onClick={() => {
                      //Note: will decide on this later
                      // window.open(item.url, '_blank');
                      publishMessageAction?.({product, event: name, payload});
                    }}
                    type="tertiary"
                    isFluid={false}
                  >
                    {item.text}
                  </Button>
                );
              default:
                return null;
            }
          })}
        </div>
      </div>
    );
  } catch {
    return null;
  }
};

export default CTAWidget;
